const containsNumbers = (str: string): boolean => {
  return /[0-9]/.test(str);
};

const containsLowerCase = (str: string): boolean => {
  return /[a-z]/.test(str);
};

const containsUpperCase = (str: string): boolean => {
  return /[A-Z]/.test(str);
};

export const verifyErrors = (value: string) => {
  return {
    charactersMin: value.length >= 8,
    lowerLetter: containsLowerCase(value),
    oneNumber: containsNumbers(value),
    uppercaseLetter: containsUpperCase(value),
  }
}
